import { STATUS } from "@constants/status.hrm";
import { URLS } from "@constants/urls";
import { DECISION_TYPE } from "@constants/workflow-decision-type";
import api from "@helpers/api";
import { UploadFileType } from "@type/HRM/upload-file";

const { START_WORKFLOW, EXECUTE_WORKFLOW } = URLS;
const { INITIATE } = DECISION_TYPE;
const { SUCCESS, FAILED } = STATUS;

const apiEndPoint = (service: string, id: string | number, url?: string) =>
  `${process.env.REACT_APP_APPROVAL_SERVICE_URL}${process.env.REACT_APP_APPROVAL_SERVICE_PORT}/${process.env.REACT_APP_APPROVAL_SERVICE}/api/${process.env.REACT_APP_API_VERSION}/${process.env.REACT_APP_API_PRIVATE}/${service}/${id}/${url}`;

export const uploadHrDocuments = (() => {
  return async (
    url: string,
    documents: UploadFileType[],
    afterEffect: (param: any) => void,
  ): Promise<{ data: any }> => {
    return api
      .post(url, documents)
      .then((response) => {
        afterEffect({
          data: response.data,
          status: SUCCESS,
        });

        return { data: response.data };
      })
      .catch((response) => {
        afterEffect({
          data: response.data,
          status: FAILED,
        });

        return { data: response.data };
      });
  };
})();

export const updateHrDocument = (() => {
  return async (
    url: string,
    document: UploadFileType,
    afterEffect: (param: any) => void,
  ): Promise<{ data: any }> => {
    return api
      .put(url, document)
      .then((response) => {
        afterEffect({
          data: response.data,
          status: SUCCESS,
        });

        return { data: response.data };
      })
      .catch((response) => {
        afterEffect({
          data: response.data,
          status: FAILED,
        });

        return { data: response.data };
      });
  };
})();

export const deleteHrDocuments = (() => {
  return async (
    url: string,
    afterEffect: (param: any) => void,
  ): Promise<{ data: any }> => {
    return api
      .delete(url)
      .then((response) => {
        afterEffect({
          data: response.data,
          status: SUCCESS,
        });

        return { data: response.data };
      })
      .catch((response) => {
        afterEffect({
          data: response.data,
          status: FAILED,
        });

        return { data: response.data };
      });
  };
})();

export const startWorkflow = (() => {
  return async (
    service: string,
    id: string | number,
    nextReviewerId: number,
    afterEffect: (param: any) => void,
    letter?: string,
  ): Promise<{ data: any }> => {
    return api
      .post(apiEndPoint(service, id as number, START_WORKFLOW), {
        decisionType: INITIATE,
        nextReviewerId,
        letter: letter ? letter : null,
      })
      .then((response) => {
        afterEffect({
          data: response,
          status: SUCCESS,
        });

        return { data: response.data };
      })
      .catch((response) => {
        afterEffect({
          data: response,
          status: FAILED,
        });

        return { data: response.data };
      });
  };
})();

export const executeWorkflow = (() => {
  return async (
    service: string,
    id: string | number,
    data: any,
    afterEffect: (param: any) => void,
  ): Promise<{ data: any }> => {
    return api
      .post(apiEndPoint(service, id, EXECUTE_WORKFLOW), {
        ...data,
      })
      .then((response) => {
        afterEffect({
          data: response,
          status: SUCCESS,
        });

        return { data: response.data };
      })
      .catch((response) => {
        afterEffect({
          data: response,
          status: FAILED,
        });

        return { data: response.data };
      });
  };
})();
